export const post = async (requestData, endpoint = "/administration") => {
  try {
    const response = await fetch(process.env.REACT_APP_CMC_API + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(requestData),
    });
    return await response.json();
  } catch (error) {
    console.error("Error sending data to the API", error);
    return { error: error.message, status: "error" };
  }
};

export const get = async (endpoint = "/administration") => {
  try {
    const response = await fetch(process.env.REACT_APP_CMC_API + endpoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching data from the API", error);
    return { error: error.message, status: "error" };
  }
};

export const put = async (requestData, endpoint = "/administration") => {
  try {
    const response = await fetch(process.env.REACT_APP_CMC_API + endpoint, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(requestData),
    });
    return await response.json();
  } catch (error) {
    console.error("Error sending data to the API", error);
    return { error: error.message, status: "error" };
  }
};
